import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useBroadcastContext } from '../contexts/BroadcastContext.jsx';
import LoadingComponent from '../../../shared/LoadingComponent';

export const StepContainer = ({ step }) => {
  const { isFetching } = useBroadcastContext();

  if (isFetching) return <LoadingComponent />;

  return (
    <Container>
      <Wrapper>{step}</Wrapper>
    </Container>
  );
};

const Container = styled.div``;

const Wrapper = styled.div`
  background: ${themeGet('colors.white')};
  border-radius: 8px;
  border: 1px solid ${themeGet('colors.black.10')};
`;
